import { useMemo } from 'react';
import { CameraProps, DocType } from '../types';

import IdentityFrame from '../components/identity-frame';
import SelfieFrame from '../components/selfie-frame/SelfieFrame';

interface UseGetCameraFrameOptions {
  cameraFacing: CameraProps['cameraFacing'];
  docType: DocType;
}

function useGetCameraFrame({
  cameraFacing,
  docType,
}: UseGetCameraFrameOptions) {
  return useMemo(() => {
    if (cameraFacing === 'back') {
      return <IdentityFrame docType={docType} />;
    }

    return <SelfieFrame docType={docType} />;
    // Expect to be initialize only on first load
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
export default useGetCameraFrame;
